<template>
  <div>
    <section class="content">

       <!-- Default box -->
      <div class="info-box"  v-if="canAccess('salary-disbursement-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Salary Record List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('salary-disbursement-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr.</th>
                <th>Name</th>
                <th class="hidden-xs">Mobile</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Salary</th>
                <th class="hidden-xs">Payment Mode</th>
                <th class="hidden-xs">Transaction Dt</th>
                <th class="hidden-xs">Cheque Dt</th>
                <th class="hidden-xs">Salary Month</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>
                <!-- <th>Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td><i v-if="row.employee">{{ row.employee.name }} ({{ row.employee.code}})</i></td>
                <td class="hidden-xs"><i v-if="row.employee">{{ row.employee.mobile }}</i></td>
                <td class="hidden-xs"><i v-if="row.branch">{{ row.branch.name }}</i></td>
                <td class="hidden-xs">{{row.salary}}</td>
                <td class="hidden-xs">{{row.payMode}}</td>
                <td class="hidden-xs">{{row.transactionDate | myDate}}</td>
                <td class="hidden-xs">{{row.chequeDate | myDate}}</td>
                <td class="hidden-xs">{{row.remark}}</td>
                <td class="hidden-xs">
                  <i v-if="row.status === 'approved'" class="text-success">{{row.status}}</i>
                  <i v-if="row.status === 'pending'" class="text-warning">{{row.status}}</i>
                </td>
                <td>
                  <div class="btn-group">
                    <button
                        v-if="canAccess('salary-disbursement-view')"
                        @click="viewModal(row)"
                        class="btn btn-info btn-xs"
                      >
                        <i class="fa fa-eye"></i>
                    </button>
                    <button
                        v-if="canAccess('salary-disbursement-view')"
                        @click="viewSalaryModal(row)"
                        class="btn btn-primary btn-xs"
                      >
                        <i class="fa fa-print"></i>
                    </button>
                    <button
                        v-if="canAccess('salary-disbursement-delete')"
                        @click="deleteModal(row.id)"
                        class="btn btn-danger btn-xs"
                      >
                        <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
      <!-- /.box -->

    </section>

        <div class="modal fade" id="newModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New Salary Disbursment</h4>
                <h4 v-show="editMode" class="modal-title">Edit Salary Disbursment</h4>
              </div>
              <form
                @submit.prevent="editMode ? updateEmployeeSalary() : createEmployeeSalary()"
              >
                <div class="modal-body">
                  <!-- right column -->
                  <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-4">
                            <!-- text input -->
                            <div class="form-group">
                              <label for="Branch">Branch</label>
                              <v-select v-model="branch" name="branch_id" label="name" :options="branches" v-on:input="loadStaff" placeholder="Select Branch"></v-select>
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Employee ID <span class="red">*</span></label>
                              <v-select v-model="staff" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getBranchAgent">

                              </v-select>
                              <has-error
                                :form="form"
                                field="agent_id"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Basic</label
                              >
                              <input
                                v-model="form.basic"
                                type="number"
                                name="basic"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('basic'),
                                }"
                                placeholder="Enter basic"
                              />
                              <has-error
                                :form="form"
                                field="basic"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >HRA</label
                              >
                              <input
                                v-model="form.houseRentAllowance"
                                type="number"
                                name="houseRentAllowance"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('houseRentAllowance'),
                                }"
                                placeholder="Enter houseRentAllowance"
                              />
                              <has-error
                                :form="form"
                                field="houseRentAllowance"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Commission</label
                              >
                              <input
                                v-model="form.commission"
                                type="number"
                                name="commission"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('commission'),
                                }"
                                placeholder="Enter commission"
                              />
                              <has-error
                                :form="form"
                                field="commission"
                              ></has-error>
                            </div><div class="form-group">
                              <label
                                >Fuel Allowance</label
                              >
                              <input
                                v-model="form.fuelAllowance"
                                type="number"
                                name="fuelAllowance"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('fuelAllowance'),
                                }"
                                placeholder="Enter fuelAllowance"
                              />
                              <has-error
                                :form="form"
                                field="fuelAllowance"
                              ></has-error>
                            </div><div class="form-group">
                              <label
                                >Mobile Allowance</label
                              >
                              <input
                                v-model="form.mobileAllowance"
                                type="number"
                                name="mobileAllowance"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('mobileAllowance'),
                                }"
                                placeholder="Enter mobileAllowance"
                              />
                              <has-error
                                :form="form"
                                field="mobileAllowance"
                              ></has-error>
                            </div><div class="form-group">
                              <label
                                >Special Allowance</label
                              >
                              <input
                                v-model="form.specialAllowance"
                                type="number"
                                name="specialAllowance"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('specialAllowance'),
                                }"
                                placeholder="Enter specialAllowance"
                              />
                              <has-error
                                :form="form"
                                field="specialAllowance"
                              ></has-error>
                            </div><div class="form-group">
                              <label
                                >Other Allowance</label
                              >
                              <input
                                v-model="form.otherAllowance"
                                type="number"
                                name="otherAllowance"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('otherAllowance'),
                                }"
                                placeholder="Enter otherAllowance"
                              />
                              <has-error
                                :form="form"
                                field="otherAllowance"
                              ></has-error>
                            </div>
                            
                          </div>
                          
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label
                                >PF Deductions</label
                              >
                              <input
                                v-model="form.pfDeductions"
                                type="number"
                                name="pfDeductions"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('pfDeductions'),
                                }"
                                placeholder="Enter pfDeductions"
                              />
                              <has-error
                                :form="form"
                                field="pfDeductions"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Advance Deductions</label
                              >
                              <input
                                v-model="form.advanceDeductions"
                                type="number"
                                name="advanceDeductions"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('advanceDeductions'),
                                }"
                                placeholder="Enter advanceDeductions"
                              />
                              <has-error
                                :form="form"
                                field="advanceDeductions"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Leaves Deductions</label
                              >
                              <input
                                v-model="form.leavesDeductions"
                                type="number"
                                name="leavesDeductions"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('leavesDeductions'),
                                }"
                                placeholder="Enter leavesDeductions"
                              />
                              <has-error
                                :form="form"
                                field="leavesDeductions"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Other Deductions</label
                              >
                              <input
                                v-model="form.otherDeductions"
                                type="number"
                                name="otherDeductions"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('otherDeductions'),
                                }"
                                placeholder="Enter otherDeductions"
                              />
                              <has-error
                                :form="form"
                                field="otherDeductions"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Total Salary<span class="red">*</span></label
                              >
                              <input
                                v-model="form.salary"
                                type="number"
                                name="salary"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('salary'),
                                }"
                                placeholder="Enter salary"
                              />
                              <has-error
                                :form="form"
                                field="salary"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Transaction Date <span class="red">*</span></label>
                              <input
                                v-model="form.transactionDate"
                                type="date"
                                name="transactionDate"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('transactionDate'),
                                }"
                                placeholder="Enter DOB"
                                required
                              />
                              <has-error :form="form" field="transactionDate"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Select Ledger Account </label>
                              <select
                                v-model="form.branch_ledger_id"
                                name="branch_ledger_id"
                                class="form-control"
                                @change="changeLedgerType()"
                                :class="{
                                  'is-invalid': form.errors.has('branch_ledger_id'),
                                }"
                              >
                                <option v-if="!form.branch_ledger_id" selected value="">
                                  Select Ledger Account
                                </option>

                                <option
                                  :value="payment_ledger.id"
                                  v-for="payment_ledger in payment_ledgers"
                                  :key="payment_ledger.id"
                                >
                                  {{payment_ledger.name}} {{payment_ledger.remark}}
                                </option>
                              </select>
                              <has-error :form="form" field="branch_ledger_id"></has-error>
                            </div>
                            <div class="form-group" v-if="ledgerType == 'bank'">
                              <label
                                >Payment Mode <span class="red">*</span></label
                              >
                              <select
                                v-model="form.payMode"
                                name="payMode"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('payMode'),
                                }"
                              >
                                <option v-if="!form.payMode" selected value="">
                                  Select Payment Method
                                </option>
                                <option value="cash">Cash</option>
                                <option value="cheque">Cheque</option>
                                <option value="online_txn">Online Transaction</option>
                              </select>
                              <has-error :form="form" field="payMode"></has-error>
                            </div>
                            <!-- text input -->
                            
                            <div class="form-group">
                              <label
                                >Salary Month<span class="red">*</span></label
                              >
                              <input
                                v-model="form.remark"
                                type="text"
                                name="remark"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('remark'),
                                }"
                                placeholder="Enter Salary Month"
                              />
                              <has-error
                                :form="form"
                                field="remark"
                              ></has-error>
                            </div>
                          </div>

                          <div class="col-sm-4">
                            <div class="form-group" v-if="ledgerType == 'bank'">
                              <label
                                >Transfer Mode <span class="red">*</span></label
                              >
                              <select
                                v-model="form.transferMode"
                                name="transferMode"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('transferMode'),
                                }"
                              >
                                <option v-if="!form.transferMode" selected value="">
                                  Select Transfer Method
                                </option>
                                <option value="imps">IMPS</option>
                                <option value="vpa">VPA</option>
                                <option value="upi">UPI</option>
                                <option value="neft">NEFT</option>
                                <option value="rtgs">RTGS</option>
                              </select>
                              <has-error :form="form" field="transferMode"></has-error>
                            </div>
                            <div class="form-group" v-if="ledgerType == 'bank'">
                              <label>Cheque Number <span class="red">*</span></label>
                              <input
                                v-model="form.chequeNo"
                                type="text"
                                name="chequeNo"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('chequeNo'),
                                }"
                                placeholder="Enter chequeNo"
                              />
                              <has-error
                                :form="form"
                                field="chequeNo"
                              ></has-error>
                            </div>
                            <div class="form-group" v-if="ledgerType == 'bank'">
                              <label
                                >Cheque Date <span class="red">*</span></label
                              >
                              <input
                                v-model="form.chequeDate"
                                type="date"
                                name="chequeDate"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('chequeDate'),
                                }"
                                placeholder="Enter joining Date"
                              />
                              <has-error
                                :form="form"
                                field="chequeDate"
                              ></has-error>
                            </div>
                            <div class="form-group" v-if="ledgerType == 'bank'">
                              <label>UTR Transaction No<span class="red">*</span></label>
                              <input
                                v-model="form.utrTransactionNo"
                                type="text"
                                name="utrTransactionNo"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('utrTransactionNo'),
                                }"
                                placeholder="Enter utrTransactionNo"
                              />
                              <has-error
                                :form="form"
                                field="utrTransactionNo"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                        <h2>Employee Bank Details</h2>
                        <div class="card-body">
                          <p>AccountHolderName : <b>{{this.form.accountHolderName}}</b></p>
                          <p>AccountNumber : <b>{{this.form.savingAccountNo}}</b></p>
                          <p>Bank : <b>{{this.form.bankName}}</b></p>
                          <p>IFSC : <b>{{this.form.ifsc}}</b></p>
                        </div>
                    </div>
                    <!-- /.card -->
                  <!--/.col (right) -->
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    SAVE
                  </button>
                  <button
                    v-show="editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <viewsalaryrecords :empInfo="empInfo"></viewsalaryrecords>
        <!-- /.modal -->
        <salaryslip :empInfo="empInfo"></salaryslip>
  </div>
</template>

<script>
import viewsalaryrecords from '../components/ViewSalaryRecords.vue'
import salaryslip from '../components/SalarySlip.vue'
import GetBranch from '../../mixins/BranchRecords'
import GetPaymentBranchLedgers from '../../mixins/PaymentBranchLedgers'
export default {
  name: 'Salary',
  components: {
    viewsalaryrecords,
    salaryslip
  },
  mixins: [GetBranch, GetPaymentBranchLedgers],
  data () {
    return {
      branches: [],
      branch: {},
      states: {},
      banks: [],
      bank: {},
      roles: [],
      staffs: [],
      staff: {},
      reasons: {},
      empInfo: {},
      payment_ledgers: [],
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      form: new Form({
        id: '',
        branch_id: '',
        employee_id: '',
        salary: '',
        bank_id: '',
        bankName: '',
        branch_ledger_id: '',
        transactionDate: new Date().toISOString().slice(0, 10),
        payMode: 'cash',
        chequeNo: '',
        chequeDate: '',
        utrTransactionNo: '',
        transferMode: '',
        savingAccountNo: '',
        accountHolderName: '',
        basic: '',
        houseRentAllowance: '',
        fuelAllowance: '',
        mobileAllowance: '',
        specialAllowance: '',
        commission: '',
        otherAllowance: '',
        pfDeductions: '',
        advanceDeductions: '',
        leavesDeductions: '',
        otherDeductions: '',
        remark: '',
        ifsc: ''
        // errors: {errors: null}
        // errors:{ 'errors': { 'name': [ 'The name field is required' ], 'mobile': [ 'The mobile field is required' ], 'branch_id': [ 'The branch id field is required' ], 'bank_id': [ 'The bank id field is required.' ], 'state_id': [ 'The state id must be a number.' ], 'pin': [ 'The pin must be a number.', 'The pin must be 6 digits.' ], 'bank_id': [ 'The bank id must be a number.' ] } }
      }),
      ledgerType: 'cash',
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    changeLedgerType () {
      var brLedger = this.form.branch_ledger_id
      var valObj = this.payment_ledgers.filter(function (elem) {
        if (elem.id === brLedger) return elem.ledger
      })
      if (valObj.length > 0) {
        if (valObj[0].ledger.id === 3) {
          this.ledgerType = 'cash'
          this.form.payMode = 'cash'
        } else {
          this.ledgerType = 'bank'
          this.form.payMode = ''
        }
      }
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      if (this.branch) {
        this.loadStaff()
      }
    },
    getBranchAgent () {
      this.form.employee_id = this.staff.user_id
      this.form.savingAccountNo = this.staff.accountNumber
      this.form.accountHolderName = this.staff.accountHolderName
      this.form.bank_id = this.staff.bank_id
      this.form.ifsc = this.staff.ifsc
      if (this.staff.bank_id) {
        this.form.bankName = this.staff.bank.name
      }
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.email = row.user.email
      this.form.mobile = row.user.mobile
      this.form.name = row.user.name
      this.form.role_id = row.user.role_id
    },
    viewModal (row) {
      this.editMode = false
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.empInfo = row
    },
    viewSalaryModal (row) {
      this.empInfo = {}
      this.editMode = false
      this.form.reset()
      $('#viewSalaryModal').modal({backdrop: 'static', keyboard: false})
      this.empInfo = row
    },
    createEmployeeSalary () {
      this.$axios
        .post('salarydisbursement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Salary Disbursed Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateEmployeeSalary () {
      this.$axios
        .put('salarydisbursement/' + this.form.id, this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Salary Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('salarydisbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    loadData () {
      this.$axios
        .get('salarydisbursement?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'salarydisbursement'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    loadStaff () {
      this.form.branch_id = this.branch.id
      this.getPaymentBranchLedgers()
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.agent_id === item.user.id) {
              this.staff = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  created () {
    this.changeFilter()
    this.getBranch()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>



// WEBPACK FOOTER //
// Salary.vue?69375a66